import { render, staticRenderFns } from "./LoadTable.vue?vue&type=template&id=0a031b52&scoped=true"
import script from "./LoadTable.vue?vue&type=script&lang=ts"
export * from "./LoadTable.vue?vue&type=script&lang=ts"
import style0 from "./LoadTable.vue?vue&type=style&index=0&id=0a031b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a031b52",
  null
  
)

export default component.exports